import React, { useState, useEffect } from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';

// Icons
import IosShareIcon from '@mui/icons-material/IosShare';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import DashboardIcon from '@mui/icons-material/Dashboard';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SummarizeIcon from '@mui/icons-material/Summarize';

import IarsLogIn from './IarsLogIn';
import Executivesummary from './exectiveSummary/Executivesummary';
import Reasonwise from './resonwisewise/Reasonwise';
import DamageStockSummary from './Damagesummary/DamageStockSummary';


export default function IARS() {
    const history = useHistory();
    const location = useLocation();
    const [tabIndex, setTabIndex] = useState(0);
    const [sitemapData, setSitemapData] = useState(null);

    useEffect(() => {
        const storedSitemap = localStorage.getItem("sitemap");
        if (storedSitemap) {
            try {
                const parsed = JSON.parse(storedSitemap);
                setSitemapData(parsed);
            } catch (e) {
                console.error("Failed to parse sitemap from localStorage", e);
                setSitemapData(null);
            }
        }
    }, []);

    
    const iarsAccess = sitemapData?.IARS || [];

    const iarsTabs = [
        iarsAccess && {
            label: 'Login',
            icon: <IosShareIcon />,
            path: '/iarsloginDashboard',
            component: <IarsLogIn />
        },
        iarsAccess && {
            label: 'Executive Summary',
            icon: <FactCheckIcon />,
            path: '/iarsexecutivesummary',
            component: <Executivesummary />
        },
        iarsAccess && {
            label: 'Reasonwise Report',
            icon: <SummarizeIcon />,
            path: '/iarsreasonwise',
            component: <Reasonwise />
        },
        iarsAccess && {
            label: 'Damaged Stock Report',
            icon: <DashboardIcon />,
            path: '/damagestocksummary',
            component: <DamageStockSummary />
        }
    ].filter(Boolean);

    useEffect(() => {
        if (!iarsTabs.length) return;

        const foundIndex = iarsTabs.findIndex(tab => location.pathname === tab.path);

        if (foundIndex !== -1) {
            setTabIndex(foundIndex);
        } else {
            setTabIndex(0);
            history.replace(iarsTabs[0].path);
        }
    }, [location.pathname, iarsTabs, history]);


    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        const selectedTab = iarsTabs[newValue];
        if (selectedTab?.path) {
            console.log("Navigation path............", selectedTab)
            history.push(selectedTab.path);
        }
    };

    return (
        <Box sx={{ fontFamily: "'Inter', sans-serif", width: '100%' }}>
            {/* Toggle Button Group */}
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexWrap: 'wrap',
                    gap: 2,
                    mb: 4,
                }}
            >
                {iarsTabs.length > 0 ? (
                    <Tabs
                        value={tabIndex}
                        onChange={handleTabChange}
                        variant="scrollable"
                        scrollButtons="auto"
                        aria-label="Sales/Purchase Tabs"
                        sx={{
                            backgroundColor: '#ffffff',
                            borderRadius: '30px',
                            p: '4px',
                            maxWidth: '80%',
                            overflowX: 'auto',
                            '.MuiTab-root': {
                                width:'auto',
                                textTransform: 'uppercase',
                                fontWeight: 550,
                                fontFamily: '"Dosis", sans-serif',
                                letterSpacing: '1px',
                                fontSize: '13px',
                                minHeight: '35px',
                                borderRadius: '20px',
                                px: 2.5,
                                py: 0.9,
                                color: '#212121',
                                '&:hover': {
                                    backgroundColor: 'var(--app-bar-bg)',
                                    color: '#fff !important',
                                },
                            },
                            '.Mui-selected': {
                                backgroundColor: 'var(--app-bar-bg)',
                                color: '#fff !important',
                            },
                            '.MuiTabs-indicator': {
                                display: 'none',
                            },
                            '.MuiTabs-scrollButtons': {
                                backgroundColor: '#64b5f6',
                                borderRadius: '50%',
                                '&.Mui-disabled': {
                                  opacity: 0.3,
                                },
                              },
                        }}
                    >
                        {iarsTabs.map((tab, index) => (
                            <Tab key={index} icon={tab.icon} iconPosition="start" label={tab.label} />
                        ))}
                    </Tabs>
                ) : null}
            </Box>

            {/* Content or Empty Message */}
            {iarsTabs.length > 0 ? (
                <Box>{iarsTabs[tabIndex]?.component}</Box>
            ) : (
                <Box
                    sx={{
                        textAlign: 'center',
                        mt: 20,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <InfoOutlinedIcon sx={{ fontSize: 64, color: '#90a4ae', mb: 2 }} />
                    <Box sx={{ fontSize: '18px', color: '#607d8b', fontFamily: '"Dosis", sans-serif', }}>
                        Please activate the IARS Services to access.
                    </Box>
                </Box>
            )}
        </Box>
    );
}      
